import { createFileRoute } from "@tanstack/react-router";

import { LibraryPage } from "@/features/library/library-page";
import { optionalString } from "@/lib/search";
import { uploadSearch, type UploadSearch } from "@/lib/upload-route";

export interface LibrarySearch extends UploadSearch {
  /** Client-side search; written with replace while typing, push on submit. */
  q?: string;
}

export const Route = createFileRoute("/")({
  validateSearch: (raw: Record<string, unknown>): LibrarySearch => ({
    q: optionalString(raw.q),
    ...uploadSearch(raw),
  }),
  component: LibraryRoute,
});

function LibraryRoute() {
  const { q } = Route.useSearch();
  return <LibraryPage query={q ?? ""} />;
}
